<template>
    <div class="main">
        <div class="flexbox ordermsg">
            <el-select v-model="seekOrderWay" placeholder="">
                <el-option
                  v-for="item in seekWay"
                  :key="item.val"
                  :label="item.name"
                  :value="item.val">
                </el-option>
            </el-select>
            <el-input v-model="orderCode" placeholder="请输入内容"></el-input>
            <el-button type="success" @click="getOrderLog">查询</el-button>
            <!-- <el-button type="danger">关闭</el-button> -->
        </div>
        <div id="mapcon"></div>
        <!-- <div id="panel"></div> -->
    </div>
</template>

<script>
    import { ref, reactive, toRefs, getCurrentInstance, onBeforeMount, onMounted } from 'vue'
    import { useRouter } from 'vue-router'
    import AMap from 'AMap'

    export default {
        name: 'VehicleTrajectory',
        setup() {
            let { proxy } = getCurrentInstance()
            let router = useRouter()
            let mapData = reactive({
                orderCode: '',
                logdata: '',
                seekOrderWay: '1',
                seekWay: [
                    {name: '子单号', val: '1'}
                ],
                seekInput: '',
                mapItem: null,
                marker: '',
                path: ''
            })
            // 查询车辆轨迹
            let getOrderLog = () => {
                // 销毁地图，并清空地图容器
                if(mapData.mapItem) {
                    mapData.mapItem.destroy();
                }
                let data = {
                    postType: 'queryCarWay',		
                    subOrderNo: mapData.orderCode, // 子单号		
                }
                proxy.$axios.postReq('/meide/REST/ajaxOrderList', data)
                .then(res => {
                    if(res.success == 'true') {
                        mapData.logdata = res.result.data
                        initMap()
                    }else {
                     

                        proxy.$alert(res.ErrorText, '提示', {
                            confirmButtonText: '确定',
                            callback: action => {}
                            
                        });
                    }
                }).catch(error => {
                    // proxy.$alert(error, '提示', {
                    //     confirmButtonText: '确定',
                    //     callback: action => {}
                    // });
                })
            }
            // 初始化地图
            let initMap = () => {
                //基本地图加载
                mapData.mapItem = new AMap.Map("mapcon", {
                    resizeEnable: true,
                    center: [116.397428, 39.90923],//地图中心点
                    zoom: 13 //地图显示的缩放级别
                })
                AMap.plugin('AMap.Driving', function() {
                    var driving = new AMap.Driving({
                        // 驾车路线规划策略，AMap.DrivingPolicy.LEAST_TIME是最快捷模式
                        policy: AMap.DrivingPolicy.LEAST_TIME,
                        map: mapData.mapItem,
                        // panel: "panel"
                    })
                    
                    var startLngLat = [116.379028, 39.865042]
                    var endLngLat = [116.427281, 39.903719]

                    driving.search(startLngLat, endLngLat, function (status, result) {
                    // result 即是对应的驾车导航信息，相关数据结构文档请参考  https://lbs.amap.com/api/javascript-api/reference/route-search#m_DrivingResult
                        if (status === 'complete') {
                            // console.log('绘制驾车路线完成')
                        } else {
                            // console.log('获取驾车数据失败：' + result)
                        }
                    })
                })
            }
            onBeforeMount(() => {
                mapData.orderCode = router.currentRoute.value.query.ordercode
            })
            onMounted(() => {
                getOrderLog()
            })

            return {
                ...toRefs(mapData),
                getOrderLog,
                initMap
            }
        }
    }
</script>

<style scoped lang="scss">
    .main {
        
    }
    #mapcon {
        width: 100vw;
        height: 100vh;
    }
    /* #panel {
        position: fixed;
        background-color: white;
        max-height: 90%;
        overflow-y: auto;
        top: 10px;
        right: 10px;
        width: 280px;
    }
    #panel .amap-call {
        background-color: #009cf9;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
    }
    #panel .amap-lib-driving {
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
        overflow: hidden;
    } */
    .ordermsg {
        position: fixed;
        top: 20px;
        left: 20px;
        z-index: 99;
        ::v-deep(.el-input) {
            margin-right: 10px;
        }
        ::v-deep(.el-select) {
            margin-right: 10px;
        }
        ::v-deep(.el-button) {
            height: 35px;
            width: 90px;
        }
    }
</style>